import { z } from 'zod'

const useZodErrorMap = () => {
  const customErrorMap: z.ZodErrorMap = (issue, ctx) => {
    if (issue.code === z.ZodIssueCode.invalid_type) {
      if (issue.expected === 'string') {
        return { message: t('zodI18n.errors.invalid_type_received_undefined') }
      }
    }
    if (issue.code === z.ZodIssueCode.custom) {
      if (issue.params && issue.params.minimum) {
        return {
          message: t('zodI18n.errors.too_small.string.inclusive', {
            minimum: issue.params.minimum,
          }),
        }
      }
    }
    if (issue.code === z.ZodIssueCode.invalid_string) {
      if (issue.validation === 'email') {
        return { message: t('zodI18n.errors.invalid_string.email') }
      }
    }
    return { message: ctx.defaultError }
  }

  return customErrorMap
}

const customErrorMap = useZodErrorMap()
z.setErrorMap(customErrorMap)
